import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H2 } from 'foundations-components/transitional/components/H2';
import FreePriceDisplayStyled from '../../components/merch-card/price-display/FreePriceDisplayStyled';
import { MerchCardLayoutUI } from '../components/MerchCardLayoutUI';
import { useIsUngatedForInbound25 } from '../hooks/useIsUngated';
import { useIsInAppAuth } from '../hooks/useUserInfo';
import { FreeToolsPurchaseMotion } from './FreeToolsPurchaseMotion';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FreeToolsMerchCard = ({
  HubDescription,
  ProductIcon,
  Title,
  Features,
  trackingSource
}) => {
  const isUngatedForInbound25 = useIsUngatedForInbound25();
  const isInApp = useIsInAppAuth();
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `free-tools-merch-card-${trackingSource}`,
    "data-selenium-id": `free-tools-merch-card-${trackingSource}`,
    columnStart: 0,
    Title: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      children: [ProductIcon, /*#__PURE__*/_jsx(H2, {
        typography: "heading-400",
        children: Title
      })]
    }),
    Subheading: HubDescription,
    Pricing: /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FreePriceDisplayStyled, {})
    }),
    CTAs: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
      trackingSource: trackingSource,
      sourceId: "free-tools-merch-card",
      isInApp: isInApp
    }),
    Features: Features,
    isUngatedForInbound25: isUngatedForInbound25
  });
};